<template>
	<section>

        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="filters">
                <el-form-item class="pull-right">
                    <el-button type="primary" @click="showAdd">Add Category</el-button>
                    <el-button type="primary" @click="showUserRate">User Rate</el-button>
                </el-form-item>
            </el-form>
        </el-col>

		<!--列表-->
		<el-table stripe :data="boxSizes" highlight-current-row v-loading="firstLoading" style="width: 100%;">
			<el-table-column prop="sizeDefined" label="Full Label" >
			</el-table-column>
			<el-table-column prop="sizeLabel" label="Short Label"  >
			</el-table-column>
			<el-table-column prop="inboundBaseFee" label="Inbound Base Fee">
			</el-table-column>
            <el-table-column prop="inboundRate" label="Inbound Rate">
            </el-table-column>
            <el-table-column prop="outboundBaseFee" label="Outbound Base Fee">
            </el-table-column>
            <el-table-column prop="outboundRate" label="Outbound Rate">
            </el-table-column>
            <el-table-column prop="storageBaseFee" label="Storage Base Fee">
            </el-table-column>
            <el-table-column prop="storageBaseFeeOver" label="Storage Base Fee > Years">
            </el-table-column>
            <el-table-column prop="isPrintBarCode" label="Print Bar Code" :formatter="formatPrintStatus" >
            </el-table-column>
			<el-table-column label="Action">
                <template slot-scope="scope">
                    <el-button size="small" @click="showEdit(scope.row)">Edit</el-button>
                </template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handlePageChange" :page-size="pageSize" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

        <!--添加界面-->
        <el-dialog title="Add Category" width="80%" :visible.sync="addFormVisible" :close-on-click-modal="false">
            <el-form :model="addCategory" label-width="220px" :rules="formRules" ref="addCategory">
                <el-form-item label="Short Label" prop="sizeLabel">
                    <el-input v-model="addCategory.sizeLabel" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Full Label" prop="sizeDefined">
                    <el-input v-model="addCategory.sizeDefined" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Inbound Base Fee" prop="inboundBaseFee">
                    <el-input-number :precision="4" :step="0.05" :min="0.0000" v-model="addCategory.inboundBaseFee"></el-input-number>
                </el-form-item>
                <el-form-item label="Inbound Rate" prop="inboundRate">
                    <el-input-number :precision="4" :step="0.05" :min="0.0000" v-model="addCategory.inboundRate"></el-input-number>
                </el-form-item>
                <el-form-item label="Outbound Base Fee" prop="outboundBaseFee">
                    <el-input-number :precision="4" :step="0.05" :min="0.0000" v-model="addCategory.outboundBaseFee"></el-input-number>
                </el-form-item>
                <el-form-item label="Outbound Rate" prop="outboundRate">
                    <el-input-number :precision="4" :step="0.05" :min="0.0000" v-model="addCategory.outboundRate"></el-input-number>
                </el-form-item>
                <el-form-item label="Storage Base Fee" prop="storageBaseFee">
                    <el-input-number :precision="4" :step="0.05" :min="0.0000" v-model="addCategory.storageBaseFee"></el-input-number>
                </el-form-item>
                <el-form-item label="Storage Base Fee >Years" prop="storageBaseFeeOver">
                    <el-input-number :precision="4" :step="0.05" :min="0.0000" v-model="addCategory.storageBaseFeeOver"></el-input-number>
                </el-form-item>
                <el-form-item label="Is Print Bar Code" prop="isPrintBarCode">
                    <el-select placeholder="Select Print Bar Code" v-model="addCategory.isPrintBarCode" clearable required>
                        <el-option :value="1" label="Printed"></el-option>
                        <el-option :value="0" label="Not Print"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">Close</el-button>
                <el-button type="primary" @click.native="handleAddBoxSize" :loading="editLoading">Submit</el-button>
            </div>
        </el-dialog>

        <!--修改界面-->
        <el-dialog title="Edit Category" width="80%" :visible.sync="editVisible" :close-on-click-modal="false">
            <el-form :model="editCategory" label-width="220px" :rules="editFormRules" ref="editCategory">
                <el-form-item label="Short Label" prop="sizeLabel">
                    <el-input v-model="editCategory.sizeLabel" :disabled="true" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Full Label" prop="sizeDefined">
                    <el-input v-model="editCategory.sizeDefined" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Inbound Base Fee" prop="inboundBaseFee">
                    <el-input-number :precision="4" :step="0.05" :min="0.0000" v-model="editCategory.inboundBaseFee"></el-input-number>
                </el-form-item>
                <el-form-item label="Inbound Rate" prop="inboundRate">
                    <el-input-number :precision="4" :step="0.05" :min="0.0000" v-model="editCategory.inboundRate"></el-input-number>
                </el-form-item>
                <el-form-item label="Outbound Base Fee" prop="outboundBaseFee">
                    <el-input-number :precision="4" :step="0.05" :min="0.0000" v-model="editCategory.outboundBaseFee"></el-input-number>
                </el-form-item>
                <el-form-item label="Outbound Rate" prop="outboundRate">
                    <el-input-number :precision="4" :step="0.05" :min="0.0000" v-model="editCategory.outboundRate"></el-input-number>
                </el-form-item>
                <el-form-item label="Storage Base Fee" prop="storageBaseFee">
                    <el-input-number :precision="4" :step="0.05" :min="0.0000" v-model="editCategory.storageBaseFee"></el-input-number>
                </el-form-item>
                <el-form-item label="Storage Base Fee >Years" prop="storageBaseFeeOver">
                    <el-input-number :precision="4" :step="0.05" :min="0.0000" v-model="editCategory.storageBaseFeeOver"></el-input-number>
                </el-form-item>
                <el-form-item label="Is Print Bar Code" prop="isPrintBarCode">
                    <el-select placeholder="Select Print Bar Code" v-model="editCategory.isPrintBarCode" clearable required>
                        <el-option :value="1" label="Printed"></el-option>
                        <el-option :value="0" label="Not Print"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editVisible = false">Close</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">Submit</el-button>
            </div>
        </el-dialog>

        <!--Category User表列界面-->
        <el-dialog title="User Rate List" width="80%" :visible.sync="userRateVisible" :close-on-click-modal="false">
            <!--列表-->
            <el-table stripe :data="userRates" highlight-current-row v-loading="secondLoading" style="width: 100%;">
                <el-table-column prop="doctorName" label="Doctor" >
                </el-table-column>
                <el-table-column prop="hasSingleSeted" label="Has bean set" >
                    <template slot-scope="scope">
                        <div :style="{ color: scope.row.hasSingleSeted ? 'green' : 'black' }">
                            {{ scope.row.hasSingleSeted ? "Already Set" : "Not Set" }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="Action">
                    <template slot-scope="scope">
                        <el-button size="small" @click="showCategoryEdit(scope.row.doctorNo)">Edit</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div slot="footer" class="dialog-footer">
                <el-button @click.native="userRateVisible = false;">Close</el-button>
            </div>
        </el-dialog>

        <!--Custom Category Set特殊价格设置界面-->
        <el-dialog title="Custom Category Set" width="80%" :visible.sync="customCategoryVisible" :close-on-click-modal="false">
            <!--列表-->
            <el-table stripe :data="customCategoryConfigs" highlight-current-row v-loading="thirdLoading" style="width: 100%;">
                <el-table-column prop="sizeDefined" label="Full Label" >
                    <template slot-scope="scope">
                        <div :style="{ color: scope.row.hasSingleSeted ? 'green' : 'black' }">
                            {{ scope.row.sizeDefined }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="sizeLabel" label="Short Label"  >
                    <template slot-scope="scope">
                        <div :style="{ color: scope.row.hasSingleSeted ? 'green' : 'black' }">
                            {{ scope.row.sizeLabel }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="inboundBaseFee" label="Inbound Base Fee">
                    <template slot-scope="scope">
                        <div :style="{ color: scope.row.hasSingleSeted ? 'green' : 'black' }">
                            {{ scope.row.inboundBaseFee }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="inboundRate" label="Inbound Rate">
                    <template slot-scope="scope">
                        <div :style="{ color: scope.row.hasSingleSeted ? 'green' : 'black' }">
                            {{ scope.row.inboundRate }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="outboundBaseFee" label="Outbound Base Fee">
                    <template slot-scope="scope">
                        <div :style="{ color: scope.row.hasSingleSeted ? 'green' : 'black' }">
                            {{ scope.row.outboundBaseFee }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="outboundRate" label="Outbound Rate">
                    <template slot-scope="scope">
                        <div :style="{ color: scope.row.hasSingleSeted ? 'green' : 'black' }">
                            {{ scope.row.outboundRate }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="storageBaseFee" label="Storage Base Fee">
                    <template slot-scope="scope">
                        <div :style="{ color: scope.row.hasSingleSeted ? 'green' : 'black' }">
                            {{ scope.row.storageBaseFee }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="storageBaseFeeOver" label="Storage Base Fee > Years">
                    <template slot-scope="scope">
                        <div :style="{ color: scope.row.hasSingleSeted ? 'green' : 'black' }">
                            {{ scope.row.storageBaseFeeOver }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="Action">
                    <template slot-scope="scope">
                        <el-button size="small" @click="showCustomEdit(scope.row)">Edit</el-button>
                        <el-button size="small" @click="deleteCustomItem(scope.row)" v-if="scope.row.hasSingleSeted">Restore</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div slot="footer" class="dialog-footer">
                <el-button @click.native="customCategoryVisible = false;getAllUserRate()">Close</el-button>
            </div>
        </el-dialog>

        <!--修改界面-->
        <el-dialog title="Custom Edit Category" width="80%" :visible.sync="customEditVisible" :close-on-click-modal="false">
            <el-form :model="customEditCategory" label-width="220px" :rules="editFormRules" ref="customEditCategory">
                <el-form-item label="Short Label" prop="sizeLabel">
                    <el-input v-model="customEditCategory.sizeLabel" :disabled="true" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Full Label" prop="sizeDefined">
                    <el-input v-model="customEditCategory.sizeDefined" :disabled="true" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Inbound Base Fee" prop="inboundBaseFee">
                    <el-input-number :precision="4" :step="0.05" :min="0.0000" v-model="customEditCategory.inboundBaseFee"></el-input-number>
                </el-form-item>
                <el-form-item label="Inbound Rate" prop="inboundRate">
                    <el-input-number :precision="4" :step="0.05" :min="0.0000" v-model="customEditCategory.inboundRate"></el-input-number>
                </el-form-item>
                <el-form-item label="Outbound Base Fee" prop="outboundBaseFee">
                    <el-input-number :precision="4" :step="0.05" :min="0.0000" v-model="customEditCategory.outboundBaseFee"></el-input-number>
                </el-form-item>
                <el-form-item label="Outbound Rate" prop="outboundRate">
                    <el-input-number :precision="4" :step="0.05" :min="0.0000" v-model="customEditCategory.outboundRate"></el-input-number>
                </el-form-item>
                <el-form-item label="Storage Base Fee" prop="storageBaseFee">
                    <el-input-number :precision="4" :step="0.05" :min="0.0000" v-model="customEditCategory.storageBaseFee"></el-input-number>
                </el-form-item>
                <el-form-item label="Storage Base Fee >Years" prop="storageBaseFeeOver">
                    <el-input-number :precision="4" :step="0.05" :min="0.0000" v-model="customEditCategory.storageBaseFeeOver"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="customEditVisible = false">Close</el-button>
                <el-button type="primary" @click.native="customEditSubmit" :loading="customEditLoading">Submit</el-button>
            </div>
        </el-dialog>

	</section>
</template>


<script>
    import util from '../../common/js/util'
    import {defaultPageSize} from "../../globalVar";
    import {editBoxSize, getBoxSizeList, getBoxSizeById} from "../../api/boxsizeService";
    import {
        deleteCustomBoxSizeConfigs,
        editCustomBoxSizeConfigs,
        editCustomBoxSizeConfigsDiscount, getCustomBoxSizeById,
        getCustomBoxSizeList,
        getDoctorUserList
    } from "../../api/customBoxSizeConfigService";

    export default {
        data() {
            return {
                firstLoading: false,
                secondLoading: false,
                thirdLoading: false,
                pageSize:defaultPageSize,

                activeName:"first",

                filters: {
                    email: ''
                },

                boxSizes: [],

                userRates: [],

                customCategoryConfigs: [],

                total:0,
                page:1,

                editVisible: false,//编辑界面是否显示
                customEditVisible: false,

                editLoading: false,
                customEditLoading: false,
                editFormRules: {
                    sizeLabel: [
                        { required: true, message: 'Short label is required.', trigger: 'blur' }
                    ],
                    sizeDefined:[
                        { required: true, message: 'Full label is required.', trigger: 'blur' }
                    ],
                    inboundBaseFee:[
                        { required: true, message: 'Inbound Base Fee is required.', trigger: 'blur' }
                    ],
                    inboundRate:[
                        { required: true, message: 'Inbound Rate is required.', trigger: 'blur' }
                    ],
                    outboundBaseFee:[
                        { required: true, message: 'Outbound Base Fee is required.', trigger: 'blur' }
                    ],
                    outboundRate:[
                        { required: true, message: 'Outbound Rate is required.', trigger: 'blur' }
                    ],
                    storageBaseFee:[
                        { required: true, message: 'Storage Base Fee is required.', trigger: 'blur' }
                    ],
                    storageBaseFeeOver:[
                        { required: true, message: 'Storage Base Fee Over is required.', trigger: 'blur' }
                    ],
                    isPrintBarCode:[
                        { required: true, message: 'Please set is print bar code.', trigger: 'blur' }
                    ]
                },

                //新增界面数据
                addCategory: {
                    sizeLabel: "",
                    sizeDefined: "",
                    inboundBaseFee: 0.0,
                    inboundRate: 0.0,
                    outboundBaseFee: 0.0,
                    outboundRate: 0.0,
                    storageBaseFee: 0.0,
                    storageBaseFeeOver: 0.0,
                    desc: "",
                    isPrintBarCode: 0,
                    id:null
                },
                //编辑界面数据
                editCategory: {
                    sizeLabel: "",
                    sizeDefined: "",
                    inboundBaseFee: 0.0,
                    inboundRate: 0.0,
                    outboundBaseFee: 0.0,
                    outboundRate: 0.0,
                    storageBaseFee: 0.0,
                    storageBaseFeeOver: 0.0,
                    desc: "",
                    isPrintBarCode: 0,
                    id:null
                },

                customEditCategory: {
                    boxSizeId: null,
                    doctorNo: "",
                    inboundBaseFee: 0.0,
                    inboundRate: 0.0,
                    outboundBaseFee: 0.0,
                    outboundRate: 0.0,
                    storageBaseFee: 0.0,
                    storageBaseFeeOver: 0.0,
                    id:null
                },

                addFormVisible: false,//新增界面是否显示
                userRateVisible: false,//Category User表列界面是否显示
                customCategoryVisible: false, // 神医自定义Category设置界面是否显示

                // addLoading: false,
                formRules: {
                    sizeLabel: [
                        { required: true, message: 'Short label is required.', trigger: 'blur' }
                    ],
                    sizeDefined:[
                        { required: true, message: 'Full label is required.', trigger: 'blur' }
                    ],
                    inboundBaseFee:[
                        { required: true, message: 'Inbound Base Fee is required.', trigger: 'blur' }
                    ],
                    inboundRate:[
                        { required: true, message: 'Inbound Rate is required.', trigger: 'blur' }
                    ],
                    outboundBaseFee:[
                        { required: true, message: 'Outbound Base Fee is required.', trigger: 'blur' }
                    ],
                    outboundRate:[
                        { required: true, message: 'Outbound Rate is required.', trigger: 'blur' }
                    ],
                    storageBaseFee:[
                        { required: true, message: 'Storage Base Fee is required.', trigger: 'blur' }
                    ],
                    storageBaseFeeOver:[
                        { required: true, message: 'Storage Base Fee Over is required.', trigger: 'blur' }
                    ],
                    isPrintBarCode:[
                        { required: true, message: 'Please set is print bar code.', trigger: 'blur' }
                    ]
                }
            }
        },
        methods: {
            formatHasBeanSet(row, column) {
                if (row.hasSingleSeted === true) {
                    return "Already Set";
                } else {
                    return "Not Set";
                }
            },
            formatPrintStatus(row, column) {
                if (row.isPrintBarCode === 1) {
                    return "Printed";
                } else {
                    return "Not Print";
                }
            },
            handlePageChange(val) {
                this.page = val;
                this.getBoxSizeList();
            },
            handleAddBoxSize(){
                this.$refs.addCategory.validate((valid)=>{
                    if(valid){
                        this.loading= true;
                        let param = {
                            sizeLabel: this.addCategory.sizeLabel,
                            sizeDefined: this.addCategory.sizeDefined,
                            inboundBaseFee: this.addCategory.inboundBaseFee,
                            inboundRate: this.addCategory.inboundRate,
                            outboundBaseFee: this.addCategory.outboundBaseFee,
                            outboundRate: this.addCategory.outboundRate,
                            storageBaseFee: this.addCategory.storageBaseFee,
                            storageBaseFeeOver: this.addCategory.storageBaseFeeOver,
                            desc: this.addCategory.desc,
                            isPrintBarCode: this.addCategory.isPrintBarCode,
                            id: null
                        };
                        editBoxSize(param).then((res)=>{
                            this.loading= false;
                            if(res.status===200){
                                this.addFormVisible = false;
                                this.$message.success(res.message);
                                this.$refs.addCategory.resetFields();
                                this.getBoxSizeList();
                            }else{
                                this.$message({
                                    message:res.message,
                                    type:"error"
                                })
                            }
                        })
                    }
                })
            },
            showAdd(){
                this.addFormVisible = true;
                this.addCategory.id = null;
                this.addCategory.sizeLabel = "";
                this.addCategory.sizeDefined = "";
                this.addCategory.inboundBaseFee = 0;
                this.addCategory.inboundRate = 0;
                this.addCategory.outboundBaseFee = 0;
                this.addCategory.outboundRate = 0;
                this.addCategory.storageBaseFee = 0;
                this.addCategory.storageBaseFeeOver = 0;
                this.addCategory.desc = "";
                this.addCategory.isPrintBarCode = 0;
            },
            showEdit(row){
                getBoxSizeById(row).then((res)=>{
                    if(res.status===200){
                        this.editVisible = true;
                        this.editCategory =  res.result;
                    }
                });
            },
            showCustomEdit(row){
                let para = {
                    doctorNo: row.doctorNo,
                    boxSizeId: row.boxSizeId,
                    id: row.id
                };
                getCustomBoxSizeById(para).then((res)=>{
                    if(res.status===200){
                        this.customEditVisible = true;
                        this.customEditCategory = res.result;
                    }
                });
            },
            deleteCustomItem(row) {
                this.editLoading = true;
                let para = {
                    doctorNo: row.doctorNo,
                    boxSizeId: row.boxSizeId,
                    id: row.id
                };
                deleteCustomBoxSizeConfigs(para).then((res)=>{
                    this.editLoading = false;
                    if(res.status===200){
                        this.$message({
                            message:res.message,
                            type:"success"
                        });
                        this.showCategoryEdit(row.doctorNo);
                        this.editVisible = false;
                    }else{
                        this.$message({
                            message:res.message,
                            type:"error"
                        })
                    }
                })
            },
            editSubmit(){
                this.editLoading = true;
                let para = {
                    sizeLabel: this.editCategory.sizeLabel,
                    sizeDefined: this.editCategory.sizeDefined,
                    inboundBaseFee: this.editCategory.inboundBaseFee,
                    inboundRate: this.editCategory.inboundRate,
                    outboundBaseFee: this.editCategory.outboundBaseFee,
                    outboundRate: this.editCategory.outboundRate,
                    storageBaseFee: this.editCategory.storageBaseFee,
                    storageBaseFeeOver: this.editCategory.storageBaseFeeOver,
                    desc: this.editCategory.desc,
                    isPrintBarCode: this.editCategory.isPrintBarCode,
                    id: this.editCategory.id
                };
                editBoxSize(para).then((res)=>{
                    this.editLoading = false;
                    if(res.status===200){
                        this.$message({
                            message:res.message,
                            type:"success"
                        });
                        this.getBoxSizeList();
                        this.editVisible = false;
                    }else{
                        this.$message({
                            message:res.message,
                            type:"error"
                        })
                    }
                })
            },
            customEditSubmit(){
                this.customEditLoading = true;
                let para = {
                    boxSizeId: this.customEditCategory.boxSizeId,
                    doctorNo: this.customEditCategory.doctorNo,
                    inboundBaseFee: this.customEditCategory.inboundBaseFee,
                    inboundRate: this.customEditCategory.inboundRate,
                    outboundBaseFee: this.customEditCategory.outboundBaseFee,
                    outboundRate: this.customEditCategory.outboundRate,
                    storageBaseFee: this.customEditCategory.storageBaseFee,
                    storageBaseFeeOver: this.customEditCategory.storageBaseFeeOver,
                    id: this.customEditCategory.id
                };
                editCustomBoxSizeConfigs(para).then((res)=>{
                    this.customEditLoading = false;
                    this.customEditVisible = false;
                    if(res.status===200){
                        this.$message({
                            message:res.message,
                            type:"success"
                        });
                        this.getDoctorCustomCategoryRate(this.customEditCategory.doctorNo);
                    }else{
                        this.$message({
                            message:res.message,
                            type:"error"
                        })
                    }
                })
            },
            getBoxSizeList(){
                let para = {
                    current: this.page,
                    size:this.pageSize
                };

                this.firstLoading = true;
                getBoxSizeList(para).then(res=>{
                    this.firstLoading = false;
                    if(res.status===200){
                        this.boxSizes = res.result.records;
                        this.total = res.result.total;
                    }else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                    }
                })
            },
            getAllUserRate(){
                let para = {
                    current: 1,
                    size: 1000
                };

                this.secondLoading = true;
                getDoctorUserList(para).then(res=>{
                    this.secondLoading = false;
                    if(res.status===200){
                        this.userRates = res.result.records;
                        this.total = res.result.total;
                    }else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                    }
                })
            },
            getDoctorCustomCategoryRate(rowDoctorNo){
                let para = {
                    current: 1,
                    size: 1000,
                    doctorNo: rowDoctorNo
                };

                this.thirdLoading = true;
                getCustomBoxSizeList(para).then(res=>{
                    this.thirdLoading = false;
                    if(res.status===200){
                        this.customCategoryConfigs = res.result;
                    }else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                    }
                })
            },
            showUserRate(){
                this.userRateVisible = true;
                this.getAllUserRate();
            },
            showCategoryEdit(rowDoctorNo){
                this.customCategoryVisible = true;
                this.getDoctorCustomCategoryRate(rowDoctorNo);
            },
        },
        mounted() {
            this.getBoxSizeList();
        }
    }

</script>


// WEBPACK FOOTER //
// boxsizes.vue?77b30dc2